export default __webpack_public_path__ + "static/media/aryash.efbae942.jpg";